import app from '@/app';
import templateUrl from './unifilarParameters-search.html';
import debounce from 'lodash/debounce';

/* @ngInject */
function UnifilarParametersSearchController(
	$controller,
	$state,
	DialogService,
	UnifilarParameters,
  Principal
) {
	var $ctrl = this;
	var resource = UnifilarParameters;

  $ctrl.currentAccount = null;
  
  Principal.identity().then(account => {
	$ctrl.currentAccount = account;
	})

	$controller('AbstractPageSortController', { $controller, $ctrl, $state });

	var transition = $ctrl.transition;

	$ctrl.transition = params => {
		transition(params);
		$ctrl.road = $ctrl.allRoads.content.find(it => it.id == params.road);
		$ctrl.campaigns = _.flow(
			_.keyBy('id'),
			_.at(params.campaigns || [])
		)($ctrl.allCampaigns.content);
		$ctrl.loading = true;
		resource.query(
			{
				plantype: 'P21',
				road: params.road,
				campaign: params.campaign,
				sort: params.sort,
				page: $ctrl.page,
				size: $ctrl.size
			},
			data => {
				$ctrl.entities = data.content;
				$ctrl.count = data.totalElements;
			}
		).$promise.finally(() => {
			$ctrl.loading = false;
		});
		$ctrl.roadtype = params.roadtype;
	};

	$ctrl.onRoadTypeChange = roadtype => {
		$ctrl.road = null;
		$ctrl.campaigns = [];
		$ctrl.campaign = null;
	};

	$ctrl.onOrganizationChange = organization => {
		$ctrl.road = null;
		$ctrl.campaigns = [];
		$ctrl.campaign = null;
	};

	$ctrl.byOrganization = value =>
		$ctrl.organization && value.organization.id == $ctrl.organization.id;

	$ctrl.byOwner = value => $ctrl.organization && value.owner.id == $ctrl.organization.id;

	$ctrl.onQueryChange = debounce(() => {
		var pCampaign = $ctrl.campaign && $ctrl.campaign.id ? $ctrl.campaign.id : null;
		var pRoad = $ctrl.road && $ctrl.road.id ? $ctrl.road.id : null;

		$ctrl.loading = true;
		resource.query(
			{
				plantype: 'P21',
				road: pRoad,
				roadtype: $ctrl.roadtype,
				campaign: pCampaign,
				sort: $ctrl.sort,
				page: 0,
				size: $ctrl.size
			},
			data => {
				$ctrl.entities = data.content;
				$ctrl.count = data.totalElements;
			}
		).$promise.finally(() => {
			$ctrl.loading = false;
		});
	}, 400);


	$ctrl.remove = (id, name) => resource.remove({ id: id }, () => $state.reload()).$promise;
}

app.component('unifilarParametersSearch', {
	templateUrl,
	controller: UnifilarParametersSearchController,
	bindings: {
		$transition$: '<',
		allOrganizations: '<',
		allRoads: '<',
		allCampaigns: '<',
		allDecisionTrees: '<',
		allCriteriaSets: '<'
	}
});
